// extracted by mini-css-extract-plugin
export default {"cardContainer":"catalog_cardContainer__Bugd-"};